import React from 'react'
import clsx from 'clsx'
import {makeStyles} from 'external/material'
import {contentLink} from 'helpers/url'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'
import Popover from '@mui/material/Popover'
import {faHistory} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import moment from 'moment'

const useStyles = makeStyles(homeworkBodyStyles)



export default function HomeworkComments({context, status, score}) {

  const classes = useStyles()
  const {translate} = context
  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleViewFilesClick = (event) => {
    setAnchorEl(event.currentTarget)
  };

  const handleClose = () => { setAnchorEl(null)  }
  const openPopOver = Boolean(anchorEl);
  const id = openPopOver ? 'popover' : undefined;

  if(status == undefined) return (<></>)

  function formatDate (date) {
    return moment(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY')
  }
  
  return (
    <>
       <span 
            onClick={(e)=> { handleViewFilesClick(e) }} 
            className={clsx(classes.commentsIcon, {hide: status.length == 0})}
            >
            <FontAwesomeIcon icon={faHistory} />
        </span>      
        <Popover
          id={id}
          open={openPopOver}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Box className={classes.commentsPopover}>
            {status != undefined && status.status.map((s, i)=> {
              const status = context.homeworkStatus[s.status]
              const statusName = translate(`homework-status-${status}`)
              return (
                <Box key={i} className={classes.comment}>                  
                  <Box className="header">
                    <div className={clsx('status-date')}>{formatDate(s.created)}</div>
                    <div className="status-score">{`${s.score || '-'} / ${score}`}</div>
                    <div className={clsx('status-name', status)}>{statusName}</div>
                  </Box>
                  <Box className="message">
                    {s.message}
                  </Box>
                </Box>)
            })}            
          </Box>          
        </Popover> 
    </>
  )
}

function homeworkBodyStyles() {
    return {   
      comment: {
        padding: '5px 0',
        borderBottom: '1px dotted #ccc',
        color: '#555',
        '& .header': {
          display: 'flex',
          '& .status-date': {
            flexGrow: 1,
          },
          '& .status-score': {
            marginRight: 20
          }
        }
      },   
      commentsPopover: {
        minWidth: 400,
        display: 'flex',
          flexDirection: 'column',
        padding: '20px 20px',
        '& .status-name': {
          padding: '0',
          color: '#fff',
          borderRadius: '20px',
          width: 80,
          textAlign: 'center',
          fontSize: '.8em',
          '&.assigned': {
            backgroundColor: '#f78d43'
          },
          '&.completed': {
            backgroundColor: '#06b71c'
          },
          '&.pending': {
            backgroundColor: '#0ac7ff'
          },
          '&.returned': {
            backgroundColor: '#ff0a0a'
          }
          
        }
      }, 
      commentsIcon: {
        color: '#128080',
        fontSize: '16pt',
        cursor: 'pointer',
        paddingRight: 26        
      },
    }
}